import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';

const isAccessAllowed = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot, authData: AuthGuardData) => {
  const { authenticated, grantedRoles, keycloak } = authData;

  // Force the user to log in if currently unauthenticated.
  if (!authenticated) {
    await keycloak.login({
      redirectUri: window.location.origin + state.url,
    });
  }

  // Get the roles required from the route.
  const requiredRoles = route.data.roles;

  // Allow the user to to proceed if no additional roles are required to access the route.
  if (!(requiredRoles instanceof Array) || requiredRoles.length === 0) {
    return true;
  }

  // Allow the user to proceed if all the required roles are present.
  const roles = [...grantedRoles.realmRoles, ...Object.values(grantedRoles.resourceRoles).flat()];
  return requiredRoles.every(role => roles.includes(role));
};

export const AuthGuard: CanActivateFn = createAuthGuard<CanActivateFn>(isAccessAllowed);
